import oAuth2 from '@/app/views/OAuth2.vue';

export default {
  path: '/oauth2/authorize',
  component: oAuth2,
  props: route => ({ code: route.query.code, type: route.params.type }),
  meta: {
    requiresAuth: true, refreshAccount: true, requiresPermission: true, app: 'ACCOUNT_MANAGEMENT',
  },
};
